import mainComponent from '@/layouts/main/Main.vue'
import fullPageComponent from '@/layouts/full-page/FullPage.vue'

export default [{
  path: '/importacoes',
  component: mainComponent,
  title: 'Importações',
  children: [{
      path: '/',
      name: 'importation-list',
      component: () => import('@/views/importation/ImportationsList.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Importações', active: true }
        ],
        pageTitle: 'Importações',
        rule: 'editor'
      }
    },
    {
      path: 'novo',
      name: 'importation-new',
      component: () => import('@/views/importation/NewImportation.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Importações', url: '/importacoes' },
          { title: 'Novo', active: true }
        ],
        pageTitle: 'Nova Importação',
        rule: 'editor'
      },
    },
    {
      path: 'editar/:idImportation',
      name: 'importation-edit',
      component: () => import('@/views/importation/ImportationEdit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Importações', url: '/importacoes' },
          { title: 'Editar', active: true }
        ],
        pageTitle: 'Editar Importação',
        rule: 'editor'
      },
    },
    {
      path: 'descricoes',
      title: 'Descrições',
      component: fullPageComponent,
      children: [{
          path: '/',
          name: 'importation-description-list',
          component: () => import('@/views/importation/descriptions/DescriptionsList.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Importações', url: '/importacoes' },
              { title: 'Descrições', active: true }
            ],
            pageTitle: 'Descrições',
            rule: 'editor'
          },
        },
        {
          path: 'novo',
          name: 'importation-description-new',
          component: () => import('@/views/importation/descriptions/NewDescription.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Importações', url: '/importacoes' },
              { title: 'Descrições', url: '/importacoes/descricoes' },
              { title: 'Novo', active: true }
            ],
            pageTitle: 'Nova Descrição',
            rule: 'editor'
          },
        },
        {
          path: 'editar/:initial',
          name: 'importation-description-edit',
          component: () => import('@/views/importation/descriptions/EditDescription.vue'),
          meta: {
            requiresAuth: true,
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Importações', url: '/importacoes' },
              { title: 'Descrições', url: '/importacoes/descricoes' },
              { title: 'Editar', active: true }
            ],
            pageTitle: 'Editar Descrição',
            rule: 'editor'
          },
        }
      ]
    }
  ],
}, ];